// @ts-ignore
import JSONInput from "react-json-editor-ajrm/es"
// @ts-ignore
import locale from "react-json-editor-ajrm/locale/en"
// @ts-ignore
import { JsonEditor as Editor } from "jsoneditor-react"
import "jsoneditor-react/es/editor.min.css"
import { Button, Typography } from "antd"
import React, { useState } from "react"

const JsonEditor = ({
  initial = {},
  onSubmit,
}: {
  initial: object
  onSubmit: any
}) => {
  const [value, setValue] = useState<any>(initial)
  return (
    <>
      <JSONInput
        id="a_unique_id"
        placeholder={initial}
        locale={locale}
        height="550px"
        width={"100%"}
        onChange={(value: any) => setValue(value)}
      />
      <Typography.Text type={"danger"}>
        Work In Progress. May not work as anticipated.
      </Typography.Text>
      <br />
      <Button
        style={{ marginTop: 10 }}
        type={"primary"}
        onClick={() => onSubmit(value?.jsObject || value)}
      >
        Update Form
      </Button>
    </>
  )
}

export default JsonEditor
